import AbstractWidget from "@/models/PlatinumWidget/AbstractWidget";
import PlatinumWidget from "@/models/PlatinumWidget/PlatinumWidget";
import PublicImage from "@/models/PublicImage/PublicImage";
import PlatinumRoute from "@/models/PlatinumRoute/PlatinumRoute";

export default class VisualLink extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/visual-link';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetVisualLinks';

    static model_name = 'VisualLink';

    static fields() {
        return {
            id: this.number(null),
            platinum_route_id: this.number(null),
            vertical_public_image_id: this.number(null).nullable(),
            horizontal_public_image_id: this.number(null).nullable(),
            title_nl: this.attr(null),
            title_en: this.attr(null),
            display_type: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(PlatinumWidget, 'widgetable_id'),
            platinumRoute: this.belongsTo(PlatinumRoute, 'platinum_route_id'),
            horizontalPublicImage: this.belongsTo(PublicImage, 'horizontal_public_image_id'),
            verticalPublicImage: this.belongsTo(PublicImage, 'vertical_public_image_id'),
        }
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return PlatinumWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }
}
